<template>
  <div class="target-data tuolele-main-box">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="选择月份">
            <el-date-picker
              v-model="search.time"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择月份"
            />
          </el-form-item>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="getTargetList"
          >查询</el-button>
        </el-form>
        <div>
          <el-button
            type="primary"
            @click="excelUpload"
          >Excel模板下载</el-button>
          <el-upload
            class="upload-demo"
            action="string"
            :with-credentials="true"
            :show-file-list="false"
            :headers="{ 'Content-Type': 'multipart/form-data' }"
            :http-request="uploadFile"
            accept=".xls"
            name="file"
          >
            <el-button slot="trigger" type="success">导入Excel表</el-button>
          </el-upload>
          <el-tooltip placement="left">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br>导入的Excel请使用Excel模板哦，否则会导入失败！
              </p>
            </div>
            <i class="el-icon-question" />
          </el-tooltip>
        </div>
      </el-row>
    </div>
    <el-table :data="tableData" border stripe>
      <el-table-column prop="name" label="店铺名称" />
      <el-table-column label="销售总额目标">
        <template slot-scope="scope">
          <span>￥{{ scope.row.value.total_price || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="新签总额目标">
        <template slot-scope="scope">
          <span>￥{{ scope.row.value.new_sign_price || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="续费总额目标">
        <template slot-scope="scope">
          <span>￥{{ scope.row.value.renew_price || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="新签人数目标">
        <template slot-scope="scope">
          <span>{{ scope.row.value.new_sign_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="累计课耗人数目标">
        <template slot-scope="scope">
          <span>{{ scope.row.value.total_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推荐新签人数目标">
        <template slot-scope="scope">
          <span>{{ scope.row.value.recommend_new_sign_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上门量目标">
        <template slot-scope="scope">
          <span>{{ scope.row.value.door_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="新增Leads数">
        <template slot-scope="scope">
          <span>{{ scope.row.value.leads_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openSetTarget(scope.row)"
          >设置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="设置"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      class="order-detail-invoice"
    >
      <el-form ref="form" :model="targetInfo" label-width="160px">
        <el-form-item label="销售总金额目标">
          <el-input
            v-model="targetInfo.total_price"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="新签金额目标">
          <el-input
            v-model="targetInfo.new_sign_price"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="新签人数目标">
          <el-input
            v-model="targetInfo.new_sign_count"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="续费金额目标">
          <el-input
            v-model="targetInfo.renew_price"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="课耗总人数目标">
          <el-input
            v-model="targetInfo.total_count"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="推荐新签人数目标">
          <el-input
            v-model="targetInfo.recommend_new_sign_count"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="上门量目标">
          <el-input
            v-model="targetInfo.door_count"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item label="新增Leads数目标">
          <el-input
            v-model="targetInfo.leads_count"
            clearable
            type="number"
          />
        </el-form-item>
        <el-form-item class="form-buttom">
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="setTarget"
          >确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import jquery from 'jquery'
export default {
  name: 'TargetData',
  data() {
    return {
      search: {
        time: ''
      },
      tableData: [],
      targetInfo: {
        total_price: '',
        new_sign_price: '',
        new_sign_count: '',
        renew_price: '',
        total_count: '',
        recommend_new_sign_count: '',
        door_count: '',
        leads_count: ''
      },
      dialogVisible: false,
      file: {}
    }
  },
  created() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    this.search.time = year + '-' + month
  },
  mounted() {
    this.getTargetList()
  },
  methods: {
    excelUpload() {
      window.location.href =
        'http://late-care.tuolele.cn/%E7%9B%AE%E6%A0%87%E8%AE%A1%E5%88%92%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls'
    },
    uploadFile(params) {
      const file = params.file
      const self = this
      const formData = new FormData()
      formData.append('file', file)
      jquery.ajax({
        url: 'http://third.tuolele.cn/cms.php/Excelupload/changeTarget',
        type: 'post',
        data: formData,
        contentType: false,
        processData: false,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(res) {
          if (res.code == 200) {
            self.$message({
              type: 'success',
              message: '导入成功！'
            })
            self.getTargetList()
          } else {
            self.$message({
              type: 'info',
              message: res.desc
            })
          }
        }
      })
    },
    getTargetList() {
      this.$http.getTargetList(this.search).then(res => {
        this.tableData = res.data || []
      })
    },
    openSetTarget(val) {
      this.dialogVisible = true
      this.targetInfo = val.value
      this.targetInfo.shop_id = val.id
      this.targetInfo.time = this.search.time
    },
    setTarget() {
      for (const key in this.targetInfo) {
        if (this.targetInfo[key] == '') {
          this.$message({
            type: 'info',
            message: '请完善目标设置内容'
          })
          return
        }
      }
      this.$http.setTarget(this.targetInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '目标设置成功！'
          })
          this.handleClose()
          this.getTargetList()
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.targetInfo = {}
      this.getTargetList()
    }
  }
}
</script>
<style lang="scss">
.target-data {
  .el-input {
    width: 150px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-button-confirm {
    margin-left: 20px;
  }
  .el-dialog .el-input {
    width: 220px;
  }
  .upload-demo {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
